import styles from "./input.module.css";
import clsx from "clsx";

export default function Input({
  helperText,
  className,
  inputClassName,
  ...props
}) {
  return (
    <div className={clsx(styles["input-container"], className)}>
      <input className={clsx(inputClassName)} {...props} />
      {helperText && <p>{helperText}</p>}
    </div>
  );
}
